import styled from 'styled-components';
import {qrShakeOnScan} from '../QrZoom/QrScanShake.css';

export const qrWrap = styled.div`
    position: relative;
    flex: 1 1 auto;
    min-height: 140px;
    aspect-ratio: 1;
    width: auto;
    height: auto;
    max-width: 200px;
    max-height: 200px;
`;

export const qr = styled.button<{$isScanning?: boolean; $canceled?: boolean}>`
    width: 100%;
    height: 100%;
    overflow: clip;
    /* gate scanners need black-on-white: white quiet zone + hard opt-out of
       dark-mode/forced-color inversion (Android Force Dark, Chrome Auto Dark) */
    padding: 8px;
    border: none;
    border-radius: 8px;
    background: #fff !important;
    color-scheme: only light;
    forced-color-adjust: none;
    cursor: zoom-in;
    display: block;

    canvas {
        /* qrcode.react sets inline width/height:200px — without !important the
           canvas keeps 200px, overflows the 8px-padded box and gets clipped */
        width: 100% !important;
        height: 100% !important;
        display: block;
        background: #fff !important;
        mix-blend-mode: normal !important;
        filter: none !important;
        -webkit-filter: none !important;
        opacity: ${p => (p.$canceled ? 0.2 : 1)};

        ${p => p.$isScanning && qrShakeOnScan}
    }
`;

export const canceledPill = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: var(--dimension-1-5) var(--dimension-5);
    border-radius: var(--radius-full);
    border: var(--dimension-0-5) solid var(--color-state-error-border);
    background: var(--color-state-error-bg);
    color: var(--primitive-red-600);
    font-size: var(--dimension-5);
    line-height: var(--dimension-6);
    font-weight: var(--font-weight-bold);
    white-space: nowrap;
    pointer-events: none;
`;
